import Navbar from './components/navbar.js'
import FormHandler from './components/form-handler.js'
import CookieConsent from './components/cookie-consent.js'

AOS.init({
  duration: 800,
  easing: 'ease-out-cubic',
  once: true,
  offset: 60
})

document.addEventListener('DOMContentLoaded', () => {
  new Navbar()
  new FormHandler()
  new CookieConsent()
})